/* @flow */
import React from 'react';
import BoxSelect from 'components/BoxSelect.jsx';
import CenteredContainer from 'components/CenteredContainer.jsx';
import BoxSelectItem from 'components/BoxSelectItem.jsx';

import './styles/ShouldLinkSmsDeviceView.scss';

class ShouldLinkSmsDeviceView extends React.Component {
  static propTypes = {
    onSelect: React.PropTypes.func.isRequired,
  };

  render() {
    return (
      <CenteredContainer size="small">
        <BoxSelect title="Did you sign up for Remind via text?">
          <BoxSelectItem
            label="Yes"
            size="xsmall"
            className="ShouldLinkSmsDeviceView-Yes"
            eventElementName="ShouldLinkSmsDeviceView-Yes"
            icon={require('assets/images/thumbs-up.svg')}
            action={() => this.props.onSelect(true)}
          />
          <BoxSelectItem
            label="No"
            size="xsmall"
            className="ShouldLinkSmsDeviceView-No"
            eventElementName="ShouldLinkSmsDeviceView-No"
            icon={require('assets/images/thumbs-down.svg')}
            action={() => this.props.onSelect(false)}
          />
        </BoxSelect>
      </CenteredContainer>
    );
  }
}

export default ShouldLinkSmsDeviceView;



// WEBPACK FOOTER //
// ./src/setup/components/ShouldLinkSmsDeviceView.jsx